<template>
  <td
    :class="{
      'yellow lighten-3': playtestData.button === 'YES'
    }"
  >
    <div
      class="d-flex flex-column"
    >
      <v-btn
        v-if="playtestData.button === 'NO'"
        outlined
        small
        :loading="loading"
        @click="openModal"
      >
        {{ playtestData.button }}
      </v-btn>
      <template v-else>
        <div class="d-flex align-center justify-space-between">
          <v-btn
            outlined
            small
            :loading="loading"
            @click="deleteData"
          >
            {{ playtestData.button }}
          </v-btn>
          <v-btn
            outlined
            x-small
            icon
            @click="openModal"
          >
            <v-icon x-small>
              {{ mdiPencil }}
            </v-icon>
          </v-btn>
        </div>
        <div class="d-flex mt-2">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                link
                x-small
                outlined
                target="_blank"
                class="mr-1"
                :to="{
                  path: '/map',
                  query: {
                    tab: 'telemetry',
                    map_id: build.map_id,
                    map_name: level,
                    map_type: 0
                  }
                }"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon x-small>
                  {{ mdiMap }}
                </v-icon>
              </v-btn>
            </template>
            <span>Playtest map</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                link
                x-small
                outlined
                target="_blank"
                class="ml-1"
                :to="{
                  path: '/telemetry/statistic',
                  query: {
                    map_id: build.map_id,
                    build_id: build.build_id
                  }
                }"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon x-small>
                  {{ mdiChartBar }}
                </v-icon>
              </v-btn>
            </template>
            <span>Playtest statistic</span>
          </v-tooltip>
        </div>
      </template>
    </div>
    <PlaytestModal
      v-if="modal"
      :item="playtestData"
      @create="createData"
      @update="updateData"
      @close="closeModal"
    />
  </td>
</template>

<script>
import { mdiChartBar, mdiMap, mdiPencil } from '@mdi/js'

export default {
  name: 'PlaytestColumn',
  components: {
    PlaytestModal: () => import('./PlaytestModal.vue')
  },
  props: {
    type: {
      type: String,
      required: true
    },
    map_alias: {
      type: String,
      required: true
    },
    level: {
      type: String,
      required: true
    },
    build: {
      type: Object,
      required: true
    },
    platform: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      mdiChartBar,
      mdiMap,
      mdiPencil,
      modal: false,
      loading: true,
      saveLoading: false,
      currentId: null,
      playtestData: {
        button: 'NO',
        date: null
      }
    }
  },
  watch: {
    'playtestData.button' (val) {
      const color = val === 'YES' ? 'yellow lighten-3' : null
      this.$emit('color', { color, build: this.build, map_alias: this.map_alias, currentId: this.currentId  })
    }
  },
  async mounted () {
    await this.loadPlaytestData()
  },
  methods: {
    async loadPlaytestData () {
      this.loading = true
      const { data } = await this.$axios.get(
        `${this.$store.getters.projectPath}/builds/${this.build.id}/${this.type}/playtest/${this.level}`
      )
      .catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else if (data) {
        this.playtestData = data
        this.currentId = data.id
      }

      this.loading = false
    },
    async createData (item) {
      this.loading = true
      const { data } = await this.$axios.post(
        `${this.$store.getters.projectPath}/builds/${this.build.id}/${this.type}/playtest/${this.level}`,
        item
      )
      .catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        this.playtestData = data
        this.currentId = data.id
      }
      this.loading = false
    },
    async updateData (item) {
      this.loading = true
      const { data } = await this.$axios.put(
        `${this.$store.getters.projectPath}/builds/${this.build.id}/${this.type}/playtest/${this.level}/${item.id}`,
        item
      )
      .catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        this.playtestData = data
        this.currentId = data.id
        this.$toasted.success('Playtest data updated')
      }
      this.loading = false
    },
    async deleteData () {
      this.loading = true
      const { data } = await this.$axios.delete(
        `${this.$store.getters.projectPath}/builds/${this.build.id}/${this.type}/playtest/${this.level}`
      )
      .catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        this.playtestData = {
          button: 'NO'
        }
      }
      this.loading = false
    },
    closeModal () {
      this.modal = false
    },
    openModal () {
      this.modal = true
    }
  }
}
</script>
